import {createReducer, createActions} from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  searchRequest: ['isShort','query'],
  searchSuccess:['data'],
  searchFailure:['error'],
});

export const SearchTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  query: null,
  data: null,
  error: null,
  fetching: false,
});

/* ------------- Reducers ------------- */

// we're attempting to ...
export const request = (state, {query}) => state.merge({query, fetching: true });

// we've successfully ...
export const success = (state, {data}) => 
  state.merge({fetching: false, error: null, data});

// we've had a problem ...
export const failure = (state, { error }) =>
  state.merge({ fetching: false, error });


/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.SEARCH_REQUEST]: request,
  [Types.SEARCH_SUCCESS]: success,
  [Types.SEARCH_FAILURE]: failure,
});
